export const ISRESULT = 'ISRESULT';
//Main
export const GET_DATA_MAIN_MENUAUTHORIZATION = 'GET_DATA_MAIN_MENUAUTHORIZATION';
export const GET_DATA_MAIN_MENUAUTHORIZATION_SUCCEEDED = 'GET_DATA_MAIN_MENUAUTHORIZATION_SUCCEEDED';
export const REQUERT_MAIN_MENUAUTHORIZATION_FAILED = 'REQUERT_MAIN_MENUAUTHORIZATION_FAILED';
export const SET_DATA_MAIN_MENUAUTHORIZATION = 'SET_DATA_MAIN_MENUAUTHORIZATION';
//User
export const GET_DATA_User = 'GET_DATA_User';
export const GET_DATA_User_SUCCEEDED = 'GET_DATA_User_SUCCEEDED';
export const REQUERT_User_FAILED = 'REQUERT_User_FAILED';
//permission
export const SET_DATA_MAIN_PERMISSION = 'SET_DATA_MAIN_PERMISSION';
export const REQUERT_PERMISSION_FAILED = 'REQUERT_PERMISSION_FAILED';

//IndexHygen